import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { AICheckbox } from '../../../../AICheckbox'
import { Avatar, AVATAR_HEIGHT_24 } from '../../../../Avatar'
import { CHECKBOX_SIZE } from '../../../../Checkbox'
import { Status } from '../../../../Status'
import Text from '../../../../Text'
import { getRequestTitle } from '../../../Request.utils'
import {
  ATTACH_SERVICE_REQUESTS_AI_CONFIDENCE_CONFIG,
  QA_NAME_ATTACH_SERVICE_REQUESTS_AI_PANEL_ROW,
} from '../../AttachServiceRequestsModal.constants'

import { getAISuggestionsPanelRowReasonText } from './AttachServiceRequestsModalAISuggestionsPanelRow.utils'

import * as styles from './AttachServiceRequestsModalAISuggestionsPanelRow.module.css'

import ServiceRequestIcon from '../../../../../icons/service-request.svg'

function AttachServiceRequestsModalAISuggestionsPanelRow({
  isSelected,
  suggestion,
  onSelect,
}) {
  const { t } = useTranslation()

  function handleClick() {
    onSelect(suggestion, !isSelected)
  }

  function handleChange(isChecked) {
    onSelect(suggestion, isChecked)
  }

  const reasonText = getAISuggestionsPanelRowReasonText(suggestion.reason, t)

  const confidenceConfig =
    ATTACH_SERVICE_REQUESTS_AI_CONFIDENCE_CONFIG[suggestion.confidence]

  const rowClassName = classNames(styles.row, {
    [styles.selected]: isSelected,
  })

  return (
    <div className={rowClassName} onClick={handleClick}>
      <AICheckbox
        checked={isSelected}
        className={styles.checkbox}
        qaName={QA_NAME_ATTACH_SERVICE_REQUESTS_AI_PANEL_ROW}
        size={CHECKBOX_SIZE.small}
        onChange={handleChange}
      />
      <Avatar
        Icon={ServiceRequestIcon}
        className={styles.avatar}
        size={AVATAR_HEIGHT_24}
      />
      <div className={styles.content}>
        <Text className={styles.title}>
          {getRequestTitle({
            requestNumber: suggestion.request_no,
            title: suggestion.title,
          })}
        </Text>
        {reasonText ? (
          <Text isSecondary className={styles.reason}>
            {reasonText}
          </Text>
        ) : null}
      </div>
      {confidenceConfig ? (
        <Status
          backgroundColor={confidenceConfig.backgroundColor}
          className={styles.confidence}
          text={t(confidenceConfig.text)}
          textColor={confidenceConfig.textColor}
        />
      ) : null}
    </div>
  )
}

export default AttachServiceRequestsModalAISuggestionsPanelRow
